import React, {ReactNode} from 'react';
import './ListViewItem.scss';
import Icon, {IconSizes} from '../../icon/Icon';
import ListViewItemPrimaryButton, {ListViewItemPrimaryButtonProps} from './ListViewItemPrimaryButton';

/**
 * Properties of the ListViewItem component.
 *
 * Since this whole component is basically just a wrapper around a ListViewItemPrimaryButton, we extend the
 * ListViewItemPrimaryButtonProps interface.
 */
export interface ListViewItemProps extends ListViewItemPrimaryButtonProps {
  confirmationMessage?: string;
}

const ListViewItem: React.FC<ListViewItemProps> = (props) => {

  function renderConfirmationMessage(): ReactNode {
    return props.confirmationMessage && (
        <div className="listview-item__copy-confirmation">
          <Icon category="fa-circle-check"
                size={IconSizes.SMALL}/>
          {props.confirmationMessage}
        </div>
    );
  }

  return <li className="listview-item">
    <ListViewItemPrimaryButton {...props}/>
    {renderConfirmationMessage()}
  </li>;
};

export default ListViewItem;
